<template>
  <vs-select v-model="dynamicFormId">
    <vs-select-item
      :key="index"
      :value="item.id"
      :text="item.title"
      v-for="(item, index) in forms"
    />
  </vs-select>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition", "automationId"],
  data() {
    return {
      dynamicFormId: "",
    };
  },
  methods: {
    render() {
      return {
        dynamicFormId: this.dynamicFormId,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      forms: "dynamicForms/dynamicForms",
    }),
  },
  async mounted() {
    await this.$store.dispatch("dynamicForms/getAll", false);
    if (this.condition) {
      this.dynamicFormId = this.condition.dynamicFormId;
    }
  },
};
</script>

<style lang="scss">
</style>